import React, { Component } from 'react';
import { connect } from 'react-redux';
import { map, each, find, reduce, filter, indexOf, head, tail, first } from 'lodash';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { Button } from 'react-bootstrap';

import { getMeta } from '../../modules/Setup/FilterReducer';


function makePaths1(paths, node, allMeta) {
  const headNode = head(paths);
  if (!headNode || !node) {
    return null;
  }
  const remainings = tail(paths);

  const isObject = node.fields !== undefined;

  const realNode = isObject ? node : find(node.fields, { name: headNode });
  
  const displays = [];

  const { label, name } = realNode;

  if (isObject) {
    displays.push({ name: headNode, label, isObject: true, isField: false });
    
    
    const sDisplays = makePaths(remainings, realNode, allMeta);
    if (sDisplays && sDisplays.length > 0) {
      each(sDisplays, (sDisplay) => {
        displays.push(sDisplay);
      });
    }
  } else if (realNode.type === 'reference') {
    const oNode = find(allMeta, { name: first(realNode.reference_to) });
    if (oNode) {
      const sDisplays = makePaths(remainings, oNode, allMeta);
      if (sDisplays && sDisplays.length > 0) {
        each(sDisplays, (sDisplay) => {
          displays.push(sDisplay);
        });
      }
    }
  } else {
    displays.push({ name: headNode, label, isObject: false, isField: true });
  }
  
  return displays; 
}


function makePaths(paths, currentNode, allMeta) {

  const shouldLogs = paths.length === 2;
  
  const headNode = head(paths);
  if (!headNode || !currentNode) {
    return null;
  }

  const remainings = tail(paths);
  const isObject = currentNode.fields !== undefined;
  const key = paths.join('.');

  let nextNode = null;


  const displays = [];
  if (isObject) {
    displays.push({ key, name: currentNode.name, label: currentNode.label, via: headNode, isObject: true, isField: false });
    const firstRemaining = first(remainings);
    if (firstRemaining) {
      nextNode = find(currentNode.fields, { name: firstRemaining });
    }
  } else if (currentNode.type === 'reference') {
    let ref = first(currentNode.reference_to);
    if (ref) {
      const refNode = find(allMeta, { name: ref }) || find(allMeta, { type: ref }); // Product2
      if (refNode) {
        displays.push({ key, name: refNode.name, label: refNode.label, via: headNode, isObject: true, isField: false });
        const firstRemaining = first(remainings);
        if (firstRemaining) {
          const currentObject = find(allMeta, { type: currentNode.object?.type });
          nextNode = find(currentObject ? currentObject.fields : refNode.fields, { name: firstRemaining });
        }
      }
    }
  } else {
    displays.push({ key, name: currentNode.name, label: currentNode.label, isObject: false, isField: true });
  }

  if (nextNode) {
    const sDisplays = makePaths(remainings, nextNode, allMeta);
    each(sDisplays, (sDisplay) => {
      if (sDisplay) {
        displays.push(sDisplay);
      }
    });
  }


  return displays; 
}

class Path extends Component {
  constructor(props) {
    super(props);
    const startingNode = find(props.meta, { type: props.startingNode });
    const paths = makePaths(props.paths, startingNode, props.meta);
    this.state = {
      paths,
    };
  }

  renderDummy() {
    const { paths } = this.props;
    const pieces = reduce(paths, (items, p, idx) => {
      items.push(<code key={p}>{p}</code>);
      if (idx < paths?.length - 1) {
        items.push(<span key={`${p}-arrow`}>&nbsp;<Fa className="text-muted" name="chevron-right" />&nbsp;</span>);
      }
      return items;
    }, []);
    return (
      <span>{pieces}</span>
    );
  }

  render() {
    const { skipMetaCheck } = this.props;
    if (skipMetaCheck) {
      return this.renderDummy();
    }
    const { paths } = this.state;
    if (!paths) {
      return (<span className="text-danger">Meta not loaded</span>);
    }
    const total = paths.length;
    if (total === 0) {
      return null;
    }
    return (
      <span>
        {paths.map((field, i) => {
          const pieces = [];
          if (field.isObject) {
            if (field.via && i > 0) {
              pieces.push(<code key={`${field.key}-name`}>{field.name}::{field.via}</code>);
            } else {
              pieces.push(<code key={`${field.key}-name`}>{field.name}</code>);
            }
          } else {
            pieces.push(<code key={`${field.key}-name`}>{(field.via || field.name)}</code>);
          }
          
          if (i < total - 1) {
            pieces.push(<span key={`${field.key}-chervon`}>&nbsp;<Fa className="text-muted" name="chevron-right" />&nbsp;</span>);
          }
          return pieces;
        })}
      </span>
    );
  }
}
function mapStateToProps(state) {
  return {
    meta: getMeta(state),
  };
}

Path.propTypes = {
  disabled: PropTypes.bool,
  paths: PropTypes.arrayOf(PropTypes.string),
  startingNode: PropTypes.string.isRequired,
  meta: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    custom: PropTypes.bool.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
      reference_to: PropTypes.arrayOf(PropTypes.string),
      sync_required: PropTypes.bool,
      is_custom: PropTypes.bool,
    })).isRequired,
  })).isRequired,
  skipMetaCheck: PropTypes.bool,
};
Path.defaultProps = {
  skipMetaCheck: false,
};


export default connect(mapStateToProps)(Path);
